// @flow
import * as React from 'react';
import {ErrorMessage, FormikProvider} from "formik";
import {useTranslation} from "react-i18next";
import {
    Button,
    FormControl,
    FormHelperText,
    TextField,
    Dialog,
    DialogContent,
    Stack,
    DialogActions,
    Box, Typography, Grid, FormLabel, DialogTitle, MenuItem
} from "@mui/material";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterMoment} from "@mui/x-date-pickers/AdapterMoment";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import {CALCULATIONS} from "../../locales/namespaces";
import useRepaymentsForm from "../../hooks/useRepaymentsForm"
import MainCard from "../../../../theme/mantis/components/mainCard";
import {NumericFormat} from "react-number-format";
import useUserData from "../../../../hooks/user/useUserData";
import CalendarIcon from "../../../../assets/images/icons/kpisIcons/calendarIcon";
import {useTheme} from "@mui/material/styles";
import moment from "moment";
const RepaymentsForm = ({
                            id,
                            open,
                            onClose,
                            handleResults,
                            calculationData,
                            contributions,
                            repayments,
                            updateRepayments,
                            handleUpdateRepayments,
                            handleRemoveRepayment,
                            RepaymentId,
                            repaymentsEdit
                        }) => {
    const {t} = useTranslation(CALCULATIONS)
    const {decimalSeparator, thousandSeparator} = useUserData()
    const theme = useTheme();
    const {formik} = useRepaymentsForm({
        id,
        handleResults,
        onClose,
        calculationData,
        contributions,
        repayments,
        updateRepayments,
        handleUpdateRepayments,
        handleRemoveRepayment,
        RepaymentId,
        repaymentsEdit
    })

    const onCloseRepayments = () => {
        onClose()
        formik.resetForm()
    }

    const futureYears =[
        {OptionId:1, name:'1'},
        {OptionId:2, name:'2'},
        {OptionId:3, name:'3'},
        {OptionId:4, name:'4'},
        {OptionId:5, name:'5'},
        {OptionId:6, name:'6'},
        {OptionId:7, name:'7'},
        {OptionId:8, name:'8'},
        {OptionId:9, name:'9'},
        {OptionId:10, name:'10'},
    ]

    return (
        <Dialog
            open={open}
            onClose={onCloseRepayments}
            sx={{maxWidth:'450px', margin:'0 auto', borderRadius:'12px'}}
        >
            <FormikProvider value={formik} >
                <Box sx={{p: 1}}>
                    <MainCard>
                        <DialogTitle>
                            
                        </DialogTitle>
                        <DialogContent>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <Stack spacing={1}>
                                        <FormControl
                                            variant="standard"
                                            fullWidth
                                            error={
                                                formik.touched["Amount"] &&
                                                Boolean(formik.errors["Amount"])
                                            }
                                        >

                                            <FormLabel htmlFor="Amount" required sx={{marginBottom:'10px'}}>
                                                {t('Repayment amount (€)')}
                                            </FormLabel>

                                            <NumericFormat
                                                value={formik.values.Amount}
                                                onValueChange={(values, sourceInfo) => {
                                                    formik.setFieldValue('Amount', values.floatValue ? values.floatValue : '')
                                                }}
                                                thousandSeparator={thousandSeparator}
                                                decimalSeparator={decimalSeparator}
                                                decimalScale={2}
                                                customInput={TextField}

                                                required
                                                onBlur={formik.handleBlur}
                                                name={`Amount`}
                                                color={"grey"}
                                                size={'small'}
                                                fullWidth
                                                inputProps={{maxLength: 100, step: 1000}}
                                                error={formik.touched.Amount && Boolean(formik.errors.Amount)}
                                            />
                                            <FormHelperText>
                                                <ErrorMessage name={"Amount"}/>
                                            </FormHelperText>
                                        </FormControl>
                                    </Stack>
                                </Grid>
                                <Grid item xs={12}>
                                    <Stack spacing={1}>
                                        <FormControl
                                            variant="standard"
                                            fullWidth
                                            error={
                                                formik.touched["Repayment_dt"] &&
                                                Boolean(formik.errors["Repayment_dt"])
                                            }
                                        >
                                            <FormLabel
                                                htmlFor="Repayment_dt" required sx={{marginBottom:'10px'}}>{t('Date of repayment')}</FormLabel>
                                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                                <DatePicker
                                                    views={['year', 'month']}
                                                    openTo="year"
                                                    inputFormat="MMMM YYYY"
                                                    value={formik.values.Repayment_dt}
                                                    minDate={calculationData?.DateInstallment ? moment(calculationData.DateInstallment).startOf('month') : undefined}
                                                    onChange={(newValue) => {
                                                        formik.setFieldValue('Repayment_dt', newValue);
                                                    }}
                                                    textField={(params) =>
                                                        <TextField {...params} />
                                                    }
                                                    slots={{
                                                        openPickerIcon: CalendarIcon
                                                    }}
                                                    sx={{
                                                        '& .MuiButtonBase-root': {
                                                            color: theme.palette.primary[100],
                                                            background: theme.palette.primary.main,
                                                        },
                                                        '& .MuiSvgIcon-root': {
                                                            order: -1,
                                                            marginRight: theme => theme.spacing(1),
                                                        },
                                                        '& .MuiInputBase-root': {
                                                            flexDirection: 'row-reverse',
                                                        },
                                                    }}
                                                />
                                            </LocalizationProvider>
                                            <FormHelperText>
                                                <ErrorMessage name={"Repayment_dt"}/>
                                            </FormHelperText>
                                        </FormControl>
                                    </Stack>
                                </Grid>
                                {/*<Grid item xs={12}>
                                    <Stack spacing={1}>
                                        <FormControl
                                            variant="standard"
                                            fullWidth
                                            error={
                                                formik.touched["NewRate"] &&
                                                Boolean(formik.errors["NewRate"])
                                            }
                                        >
                                            <FormLabel
                                                htmlFor="NewRate">{t('New interest rate (%)')}</FormLabel>
                                            <NumericFormat
                                                value={formik.values.NewRate}
                                                onValueChange={(values, sourceInfo) => {
                                                    formik.setFieldValue('NewRate', values.floatValue ? values.floatValue : '')
                                                }}
                                                thousandSeparator={thousandSeparator}
                                                decimalSeparator={decimalSeparator}
                                                decimalScale={2}
                                                customInput={TextField}

                                                onBlur={formik.handleBlur}
                                                name={`NewRate`}
                                                color={"grey"}
                                                size={'small'}
                                                fullWidth
                                                inputProps={{maxLength: 100}}
                                                error={formik.touched.NewRate && Boolean(formik.errors.NewRate)}
                                            />
                                            <FormHelperText>
                                                <ErrorMessage name={"NewRate"}/>
                                            </FormHelperText>
                                        </FormControl>
                                    </Stack>
                                </Grid>*/}
                                <Grid item xs={12}>
                                    <Stack spacing={1}>
                                            <FormControl fullWidth sx={{ mb: 2 }}>
                                                <FormLabel sx={{marginBottom:'10px'}}>
                                                    {t('Application for future years')}
                                                </FormLabel>
												<TextField
                                                    name={t('Application for future years')}
                                                    value={ formik.values.RepaymentNo }
                                                    size='small'
                                                    fullWidth={true}
													select
													onChange={(e) => {
                                                        
                                
                                                        formik.setFieldValue('RepaymentNo', e.target.value ? e.target.value: '')
                                                    }}
												>
                                                    { futureYears.map((opt) => (
                                                        <MenuItem key={opt.OptionId} value={opt.OptionId}>
                                                            {opt.name} { t('years') }
                                                        </MenuItem>
                                                    ))}
												</TextField>
											</FormControl>
                                    </Stack>
                                </Grid>



                                <Grid item xs={12}>
                                    <Button
                                        sx={{width:'100%',marginTop:'15px', marginBottom:'15px'}}
                                        variant={"contained"}
                                        color={'info'}
                                        onClick={formik.submitForm}
                                    >
                                        {t('Submit')}
                                    </Button>
                                    <Button
                                        sx={{width:'100%', color: '#4a5678 !important', backgroundColor:'#e6eaf5 !important', borderRadius:'8px !important', fontSize:'12px !important'}}
                                        variant={"light"}
                                        color={'info'}
                                        onClick={()=>{onClose()}}
                                    >
                                        {t('Close')}
                                    </Button>
                                </Grid>

                            </Grid>
                        </DialogContent>
                    </MainCard>
                </Box>
            </FormikProvider>
        </Dialog>
    )
}

export default RepaymentsForm;